var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewZealand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:53308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32 16.001C32 24.8375 24.8365 32.001 16 32.001C7.1635 32.001 0 24.8375 0 16.001C0 16.0048 16 0.00272656 16 0.000976562C24.8365 0.000976562 32 7.16448 32 16.001Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9568 16.001H15.9996C15.9996 15.9867 15.9996 15.9727 15.9996 15.9582C15.9853 15.9725 15.9711 15.9868 15.9568 16.001Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 8.34879C16 5.53348 16 3.68879 16 0.000976562H15.9973C7.162 0.00247656 0 7.16529 0 16.001H8.34781V11.3003L13.0486 16.001H15.9572C15.9715 15.9867 15.9858 15.9725 16.0001 15.9582C16.0001 14.8802 16.0001 13.9184 16.0001 13.0496L11.2992 8.34879H16Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.09515 2.08783C5.59271 3.51277 3.51234 5.59314 2.0874 8.09558V16.0009H6.26134V6.26189V6.26177H16.0005C16.0005 4.94533 16.0005 3.6912 16.0005 2.08783H8.09515Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.0008 14.0332L10.3162 8.34869C10.3162 8.34869 8.34863 8.34882 8.34863 8.34869V8.34882L16.0007 16.0008H16.0008C16.0008 16.0008 16.0008 14.6441 16.0008 14.0332Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7084 11.8734L28.0537 12.9363H29.1712L28.2671 13.5932L28.6125 14.656L27.7084 13.9992L26.8042 14.656L27.1495 13.5932L26.2454 12.9363H27.3629L27.7084 11.8734Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7134 19.5255L24.2315 21.1199H25.9078L24.5515 22.1051L25.0697 23.6994L23.7134 22.7141L22.3572 23.6994L22.8753 22.1051L21.519 21.1199H23.1954L23.7134 19.5255Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8647 7.00372L24.2964 8.33241H25.6934L24.5631 9.15334L24.9949 10.482L23.8647 9.66078L22.7346 10.482L23.1663 9.15334L22.0361 8.33241H23.433L23.8647 7.00372Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0203 11.827L20.5383 13.4214H22.2147L20.8584 14.4066L21.3766 16.0009L20.0203 15.0156L18.6641 16.0009L19.1822 14.4066L17.8259 13.4214H19.5022L20.0203 11.827Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:53308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.000976562)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewZealand);
export default __webpack_public_path__ + "static/media/new-zealand.71faa909.svg";
export { ForwardRef as ReactComponent };